import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Dropzone from "react-dropzone";
import { Editor } from "@tinymce/tinymce-react";
import { toast } from "react-toastify";

const editorFields = [
  { name: "content_1", label: "İçerik" },
  { name: "content_2", label: "Puan 1 (0-20)" },
  { name: "content_3", label: "Puan 2 (21-40)" },
  { name: "content_4", label: "Puan 3 (41-60)" },
  { name: "content_5", label: "Puan 4 (61-80)" },
  { name: "content_6", label: "Puan 5 (81-100)" },
];

const SkillEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

const [form, setForm] = useState({
  title: "",
  cover: null,
  coverUrl: "",
  gallery: null,
  galleryUrl: "",
  ...Object.fromEntries(editorFields.map(f => [f.name, ""]))
});

 useEffect(() => {
  const token = localStorage.getItem("admin_token");

  axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/skills/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(({ data }) => {
      let galleryUrl = "";
      if (data.content_images) {
        try {
          const arr = JSON.parse(data.content_images);
          if (Array.isArray(arr) && arr[0]) {
            galleryUrl = `${process.env.REACT_APP_API_BASE_URL}${arr[0]}`;
          }
        } catch (e) {
          console.warn("content_images parse hatası:", e);
        }
      }

      setForm(prev => ({
        ...prev,
        title: data.title,
        coverUrl: data.image ? `${process.env.REACT_APP_API_BASE_URL}${data.image}` : "",
        galleryUrl,
        ...editorFields.reduce((obj, f) => {
          obj[f.name] = data[f.name] || "";
          return obj;
        }, {})
      }));
    })
    .catch(err => console.error("Skill getirilemedi:", err));
}, [id]);



  /* yardımcılar */
  const update = (k,v) => setForm(p => ({ ...p, [k]: v }));
  const removeCover   = e => { e.stopPropagation(); update("cover",null); update("coverUrl",""); };
  const removeGallery = e => { e.stopPropagation(); update("gallery",null); update("galleryUrl",""); };

  /* submit */
  const handleSubmit = async e => {
    e.preventDefault();
    const token = localStorage.getItem("admin_token");

    const fd = new FormData();
    fd.append("title", form.title);
    editorFields.forEach(f => fd.append(f.name, form[f.name] || ""));
    if (form.cover)   fd.append("cover", form.cover);
    if (form.gallery) fd.append("gallery", form.gallery);

    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/skills/${id}`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Güncelleme başarılı!");
      setTimeout(() => {
        navigate("/skills/table"); // isteğe bağlı yönlendirme
      }, 1500);

    } catch (err) {
      console.error("Skill güncelleme hatası:", err);
      toast.error("Güncelleme başarısız.");
    }
  };

   const tinyInit = {
    promotion: false,
    height: 500,
    plugins: [
      "advlist", "autolink", "link", "image", "lists", "charmap",
      "preview", "anchor", "pagebreak", "searchreplace", "wordcount",
      "visualblocks", "code", "fullscreen", "insertdatetime", "media",
      "table", "emoticons", "help"
    ],
    toolbar:
      "undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | " +
      "bullist numlist outdent indent | link image | " +
      "print preview media fullscreen code | forecolor backcolor emoticons | help",
    content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",

    image_advtab:true,
    automatic_uploads:true,
    images_upload_url:`${process.env.REACT_APP_API_BASE_URL}/api/skills/upload`,
    images_upload_handler:null
  };
  
  return (
    <div className="container mt-4">
      <form className="card p-4 shadow-sm" onSubmit={handleSubmit}>

        <h5 className="fw-bold mb-3">Bilişsel Beceri Düzenle</h5>

        <div className="mb-3">
          <label className="form-label fw-bold">Başlık</label>
          <input className="form-control" value={form.title} onChange={e=>update("title",e.target.value)} required />
        </div>

        {/* Kapak */}
        <div className="mb-3">
          <label className="form-label fw-bold">Kapak Görseli</label>
          <Dropzone accept={{"image/*":[]}} maxFiles={1} onDrop={f=>update("cover",f[0])}>
            {({getRootProps,getInputProps})=>(
              <section {...getRootProps()} className="border border-dashed p-3 text-center rounded">
                <input {...getInputProps()} />
                {form.cover ? (
                  <Preview file={form.cover} onRemove={removeCover}/>
                ) : form.coverUrl ? (
                  <Preview url={form.coverUrl} onRemove={removeCover}/>
                ) : <p>Seç / Sürükle bırak</p>}
              </section>
            )}
          </Dropzone>
        </div>

        {/* Galeri */}
        <div className="mb-3">
          <label className="form-label fw-bold">İçerik Görseli</label>
          <Dropzone accept={{"image/*":[]}} maxFiles={1} onDrop={f=>update("gallery",f[0])}>
            {({getRootProps,getInputProps})=>(
              <section {...getRootProps()} className="border border-dashed p-3 text-center rounded">
                <input {...getInputProps()} />
                {form.gallery ? (
                  <Preview file={form.gallery} onRemove={removeGallery}/>
                ) : form.galleryUrl ? (
                  <Preview url={form.galleryUrl} onRemove={removeGallery}/>
                ) : <p>Seç / Sürükle bırak</p>}
              </section>
            )}
          </Dropzone>
        </div>

        {/* Editörler */}
        {editorFields.map(({ name, label }) => (
          <div className="mb-4" key={name}>
            <label className="form-label fw-bold">{label}</label>
            <Editor
              tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
              value={form[name]}
              onEditorChange={cnt => update(name, cnt)}
              init={tinyInit}
            />
          </div>
        ))}

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary btn-sm">Kaydet</button>
        </div>
      </form>
    </div>
  );
};

/* --- küçük önizleme bileşeni --- */
const Preview = ({ file, url, onRemove }) => {
  const src = file ? URL.createObjectURL(file) : url;
  return (
    <div>
      <img src={src} alt="preview" style={{ maxHeight: 120 }} className="img-thumbnail mb-2" />
      <button type="button" className="btn btn-sm btn-outline-danger" onClick={onRemove}>×</button>
    </div>
  );
};

export default SkillEdit;
